export const recentSearches = [
  "Nat's House. Address: 32 Hoover Drive, Bolson, Nevada",
];
